"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const InputLabel_1 = require("@material-ui/core/InputLabel");
exports.InputLabel = (_a) => {
    var { label, id, style } = _a, props = __rest(_a, ["label", "id", "style"]);
    // TODO: Style properly with the material theme
    const mergedStyled = Object.assign({
        display: "block",
        color: "#414141",
        fontFamily: "Poppins"
    }, style);
    return (React.createElement(InputLabel_1.default, Object.assign({ htmlFor: id, variant: "standard", style: mergedStyled }, props), label));
};
//# sourceMappingURL=InputLabel.js.map